import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';
import {format} from 'one-util-date';
import {
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET,
    SETSELECTED_ATHENA
} from 'one-state-subject/src/types';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction, resetAction
} from 'one-state-medication/src/actions';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';
export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This Fuction will fetch the data of Medication
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchMedicationAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId, teamName, alertnotification, settings: {
            servers,
            athenaendpoints: { medication },
            compatible: { consolidated_api_invocation, contact_center_type },
        } } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED_ATHENA),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the medication response
                 */
                let dataresponse: any = action.payload;
                const postMedication = (request: any) => {
                    if (request?.id) {
                        let headers = new Headers();
                        // todo need to refractor to include authorization in interface
                       
                        const data = {
                            "PatientID": request?.id.toString(),
                        }

                        let response;
                        
                        response = server.post({
                            headers: headers,
                            path: medication,
                            data: data
                        })
                            .then((medicationresponsefound: any) => medicationresponsefound)
                            .catch((medicationerror: any) => {
                                log.error(
                                    "ccw-gadget,medication-epic",
                                    "medication-epic", {
                                    medicationerror
                                }
                                );
                                let errorbuild: ErrorObject = {
                                    source: "Medication",
                                    type: "error",
                                    status: medicationerror?.status,
                                    erroritems: medicationerror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return errorbuild;
                            })
                        log.debug(
                            "ccw-gadget,medication-epic",
                            "medication-epic response", {
                            response
                        });
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                return postMedication(dataresponse).
                    pipe(
                        map((medicationresponse: any) => TransformResponse(medicationresponse, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response.medication)
                            ];
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "1008" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = response?.error?.status;
                                disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                                disp.meta05 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "191" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = dataresponse?.id;
                                disp.meta03 = '200';
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * Listen for component clear and intiate state clear for Medication
 * @param context  contains logger which is used for logging
 */
export const clearMedicationAthena = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, medication-epic",
            "clear-medication-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )
    }
);